import '../../../../style/route/api/main.css'
import { withTranslation } from 'react-i18next'
import RoundedButton from '../../../../components/Button'
import noData from 'assets/img/no-data.svg'

const EmptyState = ({ onAddNewForm, t }) => {
  return (
    <div className="form-no-data-outer-wrapper">
      <div className="form-no-data-inner-wrapper">
        <img
          src={noData}
          alt="Facebook logo"
          style={{ marginRight: '40px' }}
          height={258}
        />
        <div className="form-no-data-title">{t('form.empty.title')}</div>
        <div className="form-no-data-content">{t('form.empty.content')}</div>
        <div className="form-no-data-actions">
          <RoundedButton
            whiteTextLabel
            type="add"
            size="large"
            variant="contained"
            onClick={onAddNewForm}
            text={t('form.add')}
          />
        </div>
      </div>
    </div>
  )
}

export default withTranslation()(EmptyState)
